import { useAnnouncements } from '../hooks/useAnnouncements';
import { AnnouncementModal } from './AnnouncementModal';
import { AnnouncementBanner } from './AnnouncementBanner';

/**
 * Global announcement renderer — place once in App layout.
 * Automatically fetches and renders active announcements as modals or banners.
 */
export function AnnouncementProvider() {
  const { announcements, dismiss } = useAnnouncements();

  if (!announcements.length) return null;

  // Separate modals from banners. Show highest priority modal first.
  const modals = announcements.filter(a => a.display_type === 'modal');
  const topBanners = announcements.filter(a => a.display_type === 'banner_top');
  const bottomBanners = announcements.filter(a => a.display_type === 'banner_bottom');

  // Only show one modal at a time (highest priority first, then most recent)
  const activeModal = modals.sort((a, b) => {
    if (a.priority === 'high' && b.priority !== 'high') return -1;
    if (b.priority === 'high' && a.priority !== 'high') return 1;
    return new Date(b.created_at) - new Date(a.created_at);
  })[0];

  return (
    <>
      {/* Banners stack */}
      {topBanners.map(a => (
        <AnnouncementBanner key={a.announcement_id} announcement={a} onDismiss={dismiss} position="top" />
      ))}
      {bottomBanners.map(a => (
        <AnnouncementBanner key={a.announcement_id} announcement={a} onDismiss={dismiss} position="bottom" />
      ))}

      {/* One modal at a time */}
      {activeModal && (
        <AnnouncementModal announcement={activeModal} onDismiss={dismiss} />
      )}
    </>
  );
}
